import { List } from 'immutable';
import { bulk as bulkSelections } from '../../selections/actions/update';
import addError from '../../../utils/error.jsx';

export function request(eventId, marketId, ruleId, data) {
    return {
        type: 'MARKETS_UPDATE_RULE4_REQUEST',
        eventId,
        marketId,
        ruleId,
        data
    };
}

export function error(marketId, ruleId, errors) {
    addError(errors);

    return {
        type: 'MARKETS_UPDATE_RULE4_ERROR',
        errors,
        marketId,
        ruleId
    };
}

export function finish(marketId, ruleId, market) {
    return (dispatch) => {
        dispatch(bulkSelections(market.selections));

        market.selections = market.selections.map(x => x.id);

        dispatch({
            type: 'MARKETS_UPDATE_RULE4_FINISH',
            market,
            marketId,
            ruleId
        });
    };
}
